import React, { Component } from 'react';
import GuildItem from './GuildItem.js';

class GuildsListView extends Component {
    render() {
        return (
            <div className="guilds-list">
              {this.props.guilds.map(x => <GuildItem
                                                onClickGuild={() => this.props.onClickGuild(x)}
                                            guild={x}/>)}
            </div>
        );
    }
}

export default GuildsListView;
